@if (isLoading()) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else {
  <div class="home-container">
    <!-- Does it make sense to have editable (formatted) title? -->
    <h1 class="home-title">ESG Risk Assessment Tool</h1>

    <quill-view [content]="description()" [sanitize]="true"></quill-view>

    <div class="home-actions">
      <button mat-flat-button (click)="startAssessment()">Start New Assessment</button>
    </div>
  </div>
}
